export const getResultCounter = (fieldGroups = []) => {
  return fieldGroups.reduce((acc, item) => acc + item?.campos?.length, 0);
};
